import type { CollectionSummaryJSONObject } from '@ikegps/core-api';
import { action, observable, makeObservable } from 'mobx';
import { MapFieldsState } from './collection.form.migrate.map.fields.state';
import { getReviewableFields, type ReviewSummary } from './collection.form.migrate.review.util';

export type ReviewLossTab = 'fieldsLost' | 'dropdownLoss';

/** Drives the review step's summary. Every count — including "dropdown values lost" — is derived live
 *  from `mapFieldsState`, which owns the (one-time, up-front) fetch of the selected collections' actual
 *  field data so this step never needs to fetch anything itself. */
export class ReviewState {
	readonly mapFieldsState: MapFieldsState;
	private readonly collections: CollectionSummaryJSONObject[];
	@observable activeLossTab: ReviewLossTab = 'fieldsLost';

	constructor(mapFieldsState: MapFieldsState, collections: CollectionSummaryJSONObject[]) {
		makeObservable(this);

		this.mapFieldsState = mapFieldsState;
		this.collections = collections;
	}

	@action setActiveLossTab(tab: ReviewLossTab): void {
		this.activeLossTab = tab;
	}

	get summary(): ReviewSummary {
		const reviewableFields = getReviewableFields(this.mapFieldsState);
		const fieldsLost = this.mapFieldsState.lostFields;

		return {
			collectionsImpacted: this.collections.length,
			fieldsMapped: reviewableFields.length - fieldsLost.length,
			fieldsLost,
			dropdownValuesLost: this.mapFieldsState.dropdownValuesLostTotal,
		};
	}
}
